import { render, staticRenderFns } from "./MultiSpaceComparison.vue?vue&type=template&id=625c8fbb&"
import script from "./MultiSpaceComparison.vue?vue&type=script&lang=js&"
export * from "./MultiSpaceComparison.vue?vue&type=script&lang=js&"
import style0 from "./MultiSpaceComparison.vue?vue&type=style&index=0&id=625c8fbb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnToggle,QChip,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnToggle,QChip,QIcon})
